<div class="tz-select" [class.tz-select--compact]="compact" [class.tz-select--open]="open()">
  <button
    type="button"
    class="tz-select__trigger"
    [disabled]="disabled"
    [attr.aria-expanded]="open()"
    aria-haspopup="listbox"
    (click)="toggle()">
    <i class="pi pi-globe" aria-hidden="true"></i>
    <span class="tz-select__value">{{ selectedLabel() }}</span>
    <i class="pi" [class.pi-chevron-down]="!open()" [class.pi-chevron-up]="open()" aria-hidden="true"></i>
  </button>

  @if (open()) {
    <div class="tz-select__panel" role="listbox">
      <div class="tz-select__search">
        <i class="pi pi-search" aria-hidden="true"></i>
        <input
          type="text"
          class="tz-select__search-input"
          placeholder="Search timezone…"
          autocomplete="off"
          spellcheck="false"
          [value]="query()"
          (input)="onSearch($event)"
          (click)="$event.stopPropagation()"
          aria-label="Search timezone" />
      </div>
      <ul class="tz-select__list">
        @for (opt of filtered(); track opt.value) {
          <li>
            <button
              type="button"
              class="tz-select__option"
              [class.tz-select__option--active]="opt.value === value"
              role="option"
              [attr.aria-selected]="opt.value === value"
              (click)="select(opt.value)">
              {{ opt.label }}
            </button>
          </li>
        } @empty {
          <li class="tz-select__empty">No matching timezone</li>
        }
      </ul>
    </div>
  }
</div>
